// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/resource_status.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/resource_status.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_resource_status: GenFile = /*@__PURE__*/
  fileDesc("Cj1xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvcmVzb3VyY2Vfc3RhdHVzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEqhgEKDlJlc291cmNlU3RhdHVzEh8KG1JFU09VUkNFX1NUQVRVU19VTlNQRUNJRklFRBAAEhkKFVJFU09VUkNFX1NUQVRVU19EUkFGVBABEhoKFlJFU09VUkNFX1NUQVRVU19MT0NLRUQQAhIcChhSRVNPVVJDRV9TVEFUVVNfTU9ESUZJRUQQA2IGcHJvdG8z");

/**
 * Represents state of an abstract resource (e.g. an object that contains all
 * data associated with an experiment or assay).
 *
 * 2025-04-17: Initialized to avoid adding multiple boolean fields to
 * user-created / modified resources described by other messages.
 *
 * <see>
 * https://protobuf.dev/best-practices/api/#never-use-booleans-for-two-states
 * </see>
 *
 * @generated from enum quanterix.simoa_one.analysis_app_api.v1.ResourceStatus
 */
export enum ResourceStatus {
  /**
   * Unspecified
   *
   * @generated from enum value: RESOURCE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Draft status indicate creation and / or modification of the
   * resource is in-progress
   *
   * @generated from enum value: RESOURCE_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * Locked status indicates the resource is "read-only" and cannot be modified
   *
   * @generated from enum value: RESOURCE_STATUS_LOCKED = 2;
   */
  LOCKED = 2,

  /**
   * Modified status indicates the resource has changed from it's initial state,
   * e.g. a user-editable resource has unsaved local changes.
   *
   * @generated from enum value: RESOURCE_STATUS_MODIFIED = 3;
   */
  MODIFIED = 3,
}

/**
 * Describes the enum quanterix.simoa_one.analysis_app_api.v1.ResourceStatus.
 */
export const ResourceStatusSchema: GenEnum<ResourceStatus> = /*@__PURE__*/
  enumDesc(file_quanterix_simoa_one_analysis_app_api_v1_resource_status, 0);

